import AuthSideInfo from 'src/components/Auth/AuthSideInfo';
import SigninWrapper from 'src/components/Auth/SigninWrapper';
import Seo from 'src/components/Seo';
import seoConfig from '../../seo.json';
import { isRecruiterSide, isUniversitySide } from 'src/config/env.config';
import RecruiterAuthSideInfo from 'src/components/Auth/RecruiterAuthSideInfo';
import { useMediaQuery } from '@mui/material';
import DemoWrapper from 'src/components/Auth/DemoWrapper';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UniversityAuthSideInfo from 'src/components/Auth/UniversityAuthSideInfo';

interface Props {
	bookADemo?: boolean;
}

const SignIn = ({ bookADemo }: Props) => {
	const navigate = useNavigate();
	const isMobile = useMediaQuery('(max-width:960px)');
	const seoInfo = isRecruiterSide ? seoConfig['sign-up-recruiter'] : seoConfig['sign-in-js'];

	useEffect(() => {
		if (!isRecruiterSide && bookADemo) navigate('/auth/signin');
	}, [bookADemo, isRecruiterSide]);

	return (
		<>
			<Seo
				title={seoInfo.title}
				description={seoInfo.description}
				ogImage={
					isRecruiterSide
						? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/Hire_OG_Lanidng_Page_18f7d7326f.png'
						: undefined
				}
			/>
			<div className={`min-h-[100dvh] flex flex-col md:flex-row md:grid grid-cols-[2fr_1fr] dark:bg-[#111e2c]`}>
				{isUniversitySide ? (
					<UniversityAuthSideInfo />
				) : isRecruiterSide ? (
					<RecruiterAuthSideInfo bookADemo={bookADemo} />
				) : (
					<AuthSideInfo />
				)}
				{isRecruiterSide && !isMobile && bookADemo ? (
					<DemoWrapper />
				) : (isRecruiterSide || isUniversitySide) && isMobile ? null : (
					<SigninWrapper />
				)}
			</div>
		</>
	);
};

export default SignIn;
